import React from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import BlacklistedForm from '../components/blacklisted/BlacklistedForm'
import useBlacklistedStore from '../stores/BlacklistedStore'

export default function CreateBlacklistedPage({ building }) {
  const history = useHistory()
  const location = useLocation()

  const { blacklisted } = location.state || {}

  const create = useBlacklistedStore((state) => state.createBlacklistedItem)
  const update = useBlacklistedStore((state) => state.updateBlacklistedItem)

  return (
    <BlacklistedForm
      onSubmit={(values) => {
        if (values.id) {
          update(values)
        } else {
          create({ ...values, buildingId: building?.id })
        }
        history.push('/restringidos')
      }}
      handleCancel={() => history.push('/restringidos')}
      building={building}
      blacklisted={blacklisted}
    />
  )
}
